// extracted by mini-css-extract-plugin
module.exports = {"custom-datepicker":"dateStyle_custom-datepicker__3bBmi","dateLangDiv":"dateStyle_dateLangDiv__kfeVK","localDate":"dateStyle_localDate__3cnJM"};